import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase } from './service.base';
import { SolicitacoesCadastroClientesApi } from '../api/solicitacoes-cadastro-clientes.api';
import { ISolicitacaoCadastroClienteDTO, SolicitacaoCadastroClienteDTO } from '../dto/solicitacao-cadastro-cliente-dto';
import { ISolicitacaoCadastroCliente } from '../models/solicitacao-cadastro-cliente';
import { ICliente } from '../models/cliente';
import { SimpleSelectionModel } from '../models/simples-selection-model';
import { map } from 'rxjs/operators';

@Injectable()
export class SolicitacoesCadastroClientesService extends ServiceBase<ISolicitacaoCadastroCliente, ISolicitacaoCadastroClienteDTO> {

    constructor(private api: SolicitacoesCadastroClientesApi) {
        super(api);
    }

    checkCnpj(cnpj: string): Observable<ICliente> {
        cnpj = cnpj && cnpj.replace(/[\.\-\/]/g, '').trim();
        return this.api.doGet(`check-cnpj/${cnpj}`);
    }

    getGerentes(): Observable<SimpleSelectionModel[]> {
        return this.api.doGet(`gerentes`);
    }
    getRegionais(): Observable<SimpleSelectionModel[]> {
        return this.api.doGet(`regionais`);
    }

    reenviar(id: string): Observable<any> {
        return this.api.doGet(`reenviar/${id}`);
    }

    createAttachment(file: File): Observable<any> {
        return this.api.doPostFile("anexos", file);
    }

    readCsv(file: File): Promise<ISolicitacaoCadastroClienteDTO> {
        let promise = new Promise<ISolicitacaoCadastroClienteDTO>((resolver, rejector) => {
            this.api.doPostFile("carregar-dados", file, { responseType: "application/json" }, false)
                .pipe(map((res) => {
                    if (res.body && res.body.Id) {
                        const data = res.body;
                        delete data.Id;
                        return new SolicitacaoCadastroClienteDTO(data);
                    }
                })).subscribe((data) => data && resolver(data), err => rejector(err));
        });
        return promise;
    }

}
